import { useCoachMark } from '#hooks/useCoachMark';
import { useEffect, useState } from 'react';

interface LectureCoachMarkProps {}

const LectureCoachMark = ({}: LectureCoachMarkProps) => {
  const { isCoachMark } = useCoachMark();

  const [left, setLeft] = useState(0);

  const getLeft = () => {
    const offset = 30;

    const halfInnerWidth = window.innerWidth / 2;
    const halfMaxWidth = 500 / 2;

    if (window.innerWidth < 500) return offset;

    return halfInnerWidth - halfMaxWidth + offset;
  };

  useEffect(() => {
    setLeft(getLeft());

    window.addEventListener('resize', () => {
      setLeft(getLeft());
    });

    return () => {
      window.removeEventListener('resize', () => {
        setLeft(getLeft());
      });
    };
  }, [getLeft]);

  if (!isCoachMark) return null;

  return (
    <div
      style={{
        left: `${left}px`
      }}
      className="fixed bottom-[40px] z-1000 flex flex-col gap-20"
    >
      <div className="h-[66px] flex-col justify-center items-start inline-flex">
        <div className="self-stretch px-12 py-8 bg-[#7750e9] rounded-xl justify-center items-center gap-10 inline-flex">
          <div className="text-center text-[#f7f5ff] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            수업 일정을 한 눈에 확인하고
            <br />
            터치하면 수업 상세 내용을 확인할 수 있어요
          </div>
        </div>
        <div className="absolute top-[62px] left-[61px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="8"
            viewBox="0 0 20 8"
            fill="none"
          >
            <path
              d="M10.6247 7.50024C10.2595 7.79242 9.74052 7.79242 9.37531 7.50024L0 0L20 0L10.6247 7.50024Z"
              fill="#7750E9"
            />
          </svg>
        </div>
      </div>
      <div className="ml-40 h-[112px] w-[59px] p-8 bg-[#17161b] rounded-xl justify-start items-center gap-10 inline-flex">
        <div className="w-full h-full px-4 bg-[#aec6ee] rounded-lg flex-col justify-center items-center gap-1 inline-flex">
          <div className="self-stretch justify-center items-center gap-10 inline-flex">
            <div className="grow shrink basis-0 text-center text-[#232327] text-[13px] font-medium font-['Pretendard Variable'] leading-[18px]">
              이정서
            </div>
          </div>
          <div className="h-4 flex-col justify-center items-center gap-4 flex">
            <div className="self-stretch text-center text-[#585362] text-xs font-normal font-['Pretendard Variable'] leading-none">
              20/30
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LectureCoachMark;
